// Phase 84.M.93 — Phone verification gate (Google signin).
//
// Behaviour: any logged-in user with `auth_provider === "google"` AND
// `is_phone_verified === false` is shown a NON-DISMISSABLE modal that
// blocks the entire app until they enter + verify SĐT via Zalo ZNS OTP.
//
// User choice (tin nhắn #760): "đăng nhập lần đầu bằng google signin thì bắt
// buộc mở popup điền sđt và verify ZNS zalo xong thì mới được sử dụng tiếp,
// nếu không vào bất cứ trang nào cũng vẫn hiện popup verify cho đến khi
// hoàn tất".
//
// Routes that escape the gate (so user can still log out / hit OAuth
// callback without the modal stuck): /login, /register, /auth/callback,
// /logout, /403.
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import PhoneVerifyRequiredModal from "../components/athlete/PhoneVerifyRequiredModal";

const ESCAPE_PATHS = ["/login", "/register", "/auth/callback", "/logout", "/403"];

export function PhoneVerifyGateProvider({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  const onEscapeRoute = ESCAPE_PATHS.some((p) =>
    location.pathname === p || location.pathname.startsWith(`${p}/`)
  );

  // Spec target: Google-signin users only (auth_provider === "google").
  // is_phone_verified === false → block.
  const needsGate =
    !loading &&
    !!user &&
    user.auth_provider === "google" &&
    user.is_phone_verified === false;

  return (
    <>
      {children}
      <PhoneVerifyRequiredModal open={needsGate && !onEscapeRoute} />
    </>
  );
}
